import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { TabsModule } from '@openng/optimus-ui/tabs';

@Component({
  selector: 'app-plugins-layout',
  imports: [RouterModule, TabsModule],
  templateUrl: './plugins-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrl: './plugins-layout.component.scss'
})
export class PluginsLayoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);

  activeTabIndex = 0;
  isAdmin = false;
  canViewTelemetry = false;

  ngOnInit(): void {
    const role = this.auth.getCurrentUser()?.systemRole ?? 0;
    this.isAdmin = role === 1 || role === 2;
    this.canViewTelemetry = role === 1 || role === 2 || role === 3;

    // Redirect away from restricted tabs if not admin
    const url = this.router.url;
    if (!this.isAdmin && url.includes('/permissions')) {
      this.router.navigate(['/plugins/releases']);
      this.activeTabIndex = 0;
      return;
    }

    if (!this.canViewTelemetry && (url.includes('/telemetry') || url.includes('/qa-profiles') || url.includes('/qa-reports') || url.includes('/feedback'))) {
      this.router.navigate(['/plugins/releases']);
      this.activeTabIndex = 0;
      return;
    }

    // Set active tab index depending on role
    if (this.isAdmin) {
      if (url.includes('/permissions')) this.activeTabIndex = 1;
      else if (url.includes('/telemetry')) this.activeTabIndex = 2;
      else if (url.includes('/qa-profiles')) this.activeTabIndex = 3;
      else if (url.includes('/qa-reports')) this.activeTabIndex = 4;
      else if (url.includes('/feedback')) this.activeTabIndex = 5;
      else this.activeTabIndex = 0;
    } else {
      if (url.includes('/telemetry')) this.activeTabIndex = 1;
      else if (url.includes('/qa-profiles')) this.activeTabIndex = 2;
      else if (url.includes('/qa-reports')) this.activeTabIndex = 3;
      else if (url.includes('/feedback')) this.activeTabIndex = 4;
      else this.activeTabIndex = 0;
    }
  }

  onTabChange(event: any): void {
    // Tab change is handled by routerLink
  }
}
